module.exports = __webpack_public_path__ + "assets/svg/stop_icon_black.svg";